(() => {
  const STORAGE_KEY = "recently_viewed_products";
  const MAX_PRODUCTS = 20;

  function money(price) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(price);
    }

    return (price / 100).toFixed(2);
  }

  function saveProduct() {
    if (!window.location.pathname.startsWith("/products/")) return;

    const handle = window.location.pathname
      .split("/products/")[1]
      .split("?")[0];

    let viewed = [];

    try {
      viewed = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      viewed = [];
    }

    viewed = viewed.filter(item => item !== handle);

    viewed.unshift(handle);

    viewed = viewed.slice(0, MAX_PRODUCTS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(viewed));
  }

  async function renderRecentlyViewed() {
    const section = document.querySelector(".recently-viewed");
    if (!section) return;

    const grid = section.querySelector(".recently-viewed__grid");
    const empty = section.querySelector(".recently-viewed__empty");

    grid.innerHTML = "";

    let handles = [];

    try {
      handles = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      handles = [];
    }

    if (!handles.length) {
      empty.style.display = "block";
      return;
    }

    const limit = Number(section.dataset.limit) || 4;

    handles = handles.slice(0, limit);

    const requests = handles.map(handle =>
      fetch(`/products/${handle}.js`)
        .then(res => (res.ok ? res.json() : null))
        .catch(() => null)
    );

    const products = await Promise.all(requests);

    products.filter(Boolean).forEach(product => {

      let compare = "";

      if (
        product.compare_at_price &&
        product.compare_at_price > product.price
      ) {
        compare = `
          <span class="recently-viewed__price-compare">
            ${money(product.compare_at_price)}
          </span>
        `;
      }

      grid.insertAdjacentHTML(
        "beforeend",
        `
        <div class="recently-viewed__card">

          <a href="${product.url}" class="recently-viewed__image">
            <img
              src="${product.featured_image}"
              alt="${product.title}"
              loading="lazy">
          </a>

          <div class="recently-viewed__content">

            <div class="recently-viewed__vendor">
              ${product.vendor}
            </div>

            <a href="${product.url}" class="recently-viewed__title-link">
              ${product.title}
            </a>

            <div class="recently-viewed__price">

              <span class="recently-viewed__price-current">
                ${money(product.price)}
              </span>

              ${compare}

            </div>

          </div>

        </div>
        `
      );
    });

    empty.style.display = products.length ? "none" : "block";
  }

  saveProduct();

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", renderRecentlyViewed);
  } else {
    renderRecentlyViewed();
  }
})();